import { AutogenLayoutDispatchEquipAlerts } from "./autogen/AutogenLayoutDispatchEquipAlerts";
import { ModelRow } from "@mcleod/core";
import { TableRowDisplayEvent } from "@mcleod/components";
import { CommonTooltips } from "@mcleod/common";

export class DispatchEquipAlerts extends AutogenLayoutDispatchEquipAlerts {
    private isTooltip: boolean;

    onLoad(): void | Promise<void> {
        this.mainDataSource.addDisplayListener(() => this.hideColumnsForTooltip());
    }

    hideColumnsForTooltip() {
        if (this.isTooltip) {
            const hideColumns = ["Status", "Message Date"];
            hideColumns.forEach(caption => {
                const column = this.tableAlerts.getColumnByCaption(caption);
                if (column) {
                    this.tableAlerts.setColumnVisibility(column, false);
                }
            })
        }
    }

    /** This is an event handler for the onRowDisplay event of tableAlerts. */
    tableAlertsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const data:ModelRow = tableRow.data;
        if(data.get("priority") != "U"){
            tableRow.findComponentById("imageUrgent").visible = false;
        }

        const unitTextBox = tableRow.findComponentById("textboxUnit");
        switch(data.get("unit_type") ){
            case "D":
                unitTextBox.visible = false;
                const comp = tableRow.findComponentById("textboxDriverName");
                comp.visible = true;
                CommonTooltips.setTooltipContentLayout(comp, data.get("driver.id"), "lme/dispatch/asset/DriverQuickInfo");
                break;
            case "T":
                CommonTooltips.setTooltipContentLayout(unitTextBox,
                    data.get("unit"), "lme/dispatch/asset/TractorQuickInfo");
                break;
            case "L":
                CommonTooltips.setTooltipContentLayout(unitTextBox,
                    data.get("unit"), "lme/dispatch/asset/TrailerQuickInfo");
                break;

        }
    }
}
